document.addEventListener('DOMContentLoaded', function () {
  const filterList = document.querySelector('.product_info_btm,.hero_viewport_hs');

  if (!filterList) return;

  filterList.addEventListener('mouseenter', function () {
    filterList.classList.add('show-scrollbar');
  });

  filterList.addEventListener('mouseleave', function () {
    filterList.classList.remove('show-scrollbar');
  });
});
async function updateFreeShippingProgress(cart) {
  const message = document.querySelector('.free-shipping-progress p');
  const progressBar = document.querySelector('.free-shipping-progress-fill');

  if (!message || !progressBar) return;

  const usdThreshold = 100;

  let threshold = 10000;

  try {
    const response = await fetch('/localization.json');

    if (response.ok) {
      const localization = await response.json();

      const currency =
        localization?.country?.currency?.iso_code ||
        localization?.currency?.iso_code ||
        'USD';

      const rate =
        parseFloat(
          localization?.country?.currency?.rate ||
          localization?.currency?.rate
        ) || 1;

      threshold = Math.round(usdThreshold * 100 * rate);
    }
  } catch (error) {
    threshold = 10000;
  }

  const amountRemaining = threshold - cart.total_price;

  let progress = (cart.total_price / threshold) * 100;

  if (progress > 100) {
    progress = 100;
  }

  if (progress < 0) {
    progress = 0;
  }

  progressBar.style.width = `${progress}%`;

  if (amountRemaining > 0) {
    message.innerHTML =
      `You're <strong>${formatMoney(amountRemaining)}</strong> away from Free Shipping`;
  } else {
    message.innerHTML =
      `<strong>You unlocked Free Shipping!</strong>`;
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}
(function () {

  function roundProductPrice(priceText) {

    if (!priceText) return '';

    const match = priceText.match(
      /([^\d]*)([\d,]+(?:\.\d+)?)/
    );

    if (!match) return priceText;

    const prefix = match[1];

    const number = parseFloat(
      match[2].replace(/,/g, '')
    );

    if (isNaN(number)) return priceText;

    return (
      prefix +
      Math.round(number).toLocaleString('en-US')
    );
  }


  function updateMainProductButtonPrice() {

    const salePrice = document.querySelector(
      '[data-product-submit-price]'
    );

    const comparePrice = document.querySelector(
      '[data-product-submit-compare-price]'
    );

    if (!salePrice) return;

    const selectedInput = document.querySelector(
      'input[name="purchaseType"]:checked'
    );

    if (!selectedInput) return;


    /*
     * ONE TIME
     */
    if (
      selectedInput.value ===
      'purchaseTypeOneTime'
    ) {

      const priceElement = document.querySelector(
        '[data-stayai-onetime-price]'
      );

      if (!priceElement) return;


      const clone =
        priceElement.cloneNode(true);

      clone
        .querySelectorAll('s, del')
        .forEach(function (el) {
          el.remove();
        });


      const oneTimePrice =
        clone.textContent.trim();


      if (!oneTimePrice) return;


      salePrice.textContent =
        roundProductPrice(oneTimePrice);


      /*
       * Hide compare price for one-time
       */
      if (comparePrice) {
        comparePrice.textContent = '';
        comparePrice.style.display = 'none';
      }

      return;
    }


    /*
     * SUBSCRIPTION
     */
    if (
      selectedInput.value ===
      'purchaseTypeSubscription'
    ) {

      const priceElement = document.querySelector(
        '[data-stayai-subscription-price]'
      );

      if (!priceElement) return;


      const fullPrice =
        priceElement.querySelector('.fullPrice');


      /*
       * Subscription has TWO prices
       */
      if (fullPrice) {

        /*
         * Compare / original price
         */
        if (comparePrice) {

          comparePrice.textContent =
            roundProductPrice(
              fullPrice.textContent.trim()
            );

          comparePrice.style.display = '';
        }


        /*
         * Subscription / sale price
         */
        let subscriptionPrice =
          priceElement.textContent
            .replace(
              fullPrice.textContent,
              ''
            )
            .trim();


        if (subscriptionPrice) {

          salePrice.textContent =
            roundProductPrice(
              subscriptionPrice
            );
        }

      }

      /*
       * Subscription has only ONE price
       */
      else {

        salePrice.textContent =
          roundProductPrice(
            priceElement.textContent.trim()
          );


        if (comparePrice) {
          comparePrice.textContent = '';
          comparePrice.style.display = 'none';
        }
      }

    }

  }


  /*
   * Purchase type change
   */
  document.addEventListener(
    'change',
    function (event) {

      if (
        !event.target.matches(
          'input[name="purchaseType"]'
        )
      ) {
        return;
      }


      setTimeout(
        updateMainProductButtonPrice,
        50
      );

      setTimeout(
        updateMainProductButtonPrice,
        150
      );

      setTimeout(
        updateMainProductButtonPrice,
        300
      );

    }
  );


  /*
   * Initial load
   */
  document.addEventListener(
    'DOMContentLoaded',
    function () {

      setTimeout(
        updateMainProductButtonPrice,
        100
      );

      setTimeout(
        updateMainProductButtonPrice,
        500
      );

    }
  );


  /*
   * Watch Stay AI price changes
   */
  const observer =
    new MutationObserver(function () {

      clearTimeout(
        window.mainProductPriceTimer
      );

      window.mainProductPriceTimer =
        setTimeout(
          updateMainProductButtonPrice,
          50
        );

    });


  function startPriceObserver() {

    const oneTimePrice =
      document.querySelector(
        '[data-stayai-onetime-price]'
      );

    const subscriptionPrice =
      document.querySelector(
        '[data-stayai-subscription-price]'
      );


    if (oneTimePrice) {

      observer.observe(
        oneTimePrice,
        {
          childList: true,
          subtree: true,
          characterData: true
        }
      );

    }


    if (subscriptionPrice) {

      observer.observe(
        subscriptionPrice,
        {
          childList: true,
          subtree: true,
          characterData: true
        }
      );

    }

  }


  document.addEventListener(
    'DOMContentLoaded',
    function () {

      startPriceObserver();

      setTimeout(
        startPriceObserver,
        500
      );

      setTimeout(
        startPriceObserver,
        1000
      );

    }
  );

})();